import type { DataWorkerClient } from "owa-data-worker-utils";
import { expose } from "comlink";
import { applyTombstonesToSessionData, initialize, precompileSchema, getOfflineSessionData, saveOfflineSessionData, lazyFlushSyncLogs, lazyExecute, lazyUnsubscribe, lazyNotifySubscription, lazyInvokeWin32GqlRequestCallback, lazyInitializeDateTime, lazyInitializeApplicationSettings, lazyInitializeFeatureFlags, lazyInitializeOfflineSync, lazyGetOfflineTimeZoneOffsets, lazyGetOfflineTimeZones, lazyLoadOfflineSettings, lazySaveOfflineSettings, lazyInvalidateOfflineConversationNodes, lazyLogPeopleDataToSyncLogs, lazyLoadPeopleAppData, } from "owa-data-worker";
import { setDisableAllRequests } from "./actions/setDisableAllRequests";
import { initializeAnalyticsInWorker, updateAnalyticsCachesInWorker, } from "owa-worker-analytics-initialization";

const client: DataWorkerClient = {
    initialize,
    initializeOfflineSync: lazyInitializeOfflineSync.importAndExecute,
    execute: lazyExecute.importAndExecute,
    unsubscribe: lazyUnsubscribe.importAndExecute,
    setDisableAllRequests,
    notifySubscription: lazyNotifySubscription.importAndExecute,
    flushSyncLogs: lazyFlushSyncLogs.importAndExecute,
    initializeDateTime: lazyInitializeDateTime.importAndExecute,
    initializeAnalyticsInWorker,
    updateAnalyticsCachesInWorker,
    initializeApplicationSettings: lazyInitializeApplicationSettings.importAndExecute,
    initializeFeatureFlags: lazyInitializeFeatureFlags.importAndExecute,
    precompileSchema,
    invokeWin32GqlRequestCallback: lazyInvokeWin32GqlRequestCallback.importAndExecute,
    getOfflineSessionData,
    saveOfflineSessionData,
    getOfflineTimeZones: lazyGetOfflineTimeZones.importAndExecute,
    getOfflineTimeZoneOffsets: lazyGetOfflineTimeZoneOffsets.importAndExecute,
    loadOfflineSettings: lazyLoadOfflineSettings.importAndExecute,
    saveOfflineSettings: lazySaveOfflineSettings.importAndExecute,
    invalidateOfflineConversationNodes: lazyInvalidateOfflineConversationNodes.importAndExecute,
    logPeopleDataToSyncLogs: lazyLogPeopleDataToSyncLogs.importAndExecute,
    loadPeopleAppData: lazyLoadPeopleAppData.importAndExecute,
    applyTombstonesToSessionData,
};

// there is a rare case revealed by telemetry where the index file is executed twice when loading the worker,
// leading to two webpack runtimes, two comlink subscriptions to the message events, etc.  because of the two
// webpack runtimes, module scope variables aren't sufficient for guarding against this event, but the worker
// scope is.
if (!self.olkworkerexposed) {
    /* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
     * Worker semantics require this to be called in the worker entry point.
     *	*/
    expose(client);
    
    // there's the question of whether to mark this before or after the expose method.  if done before and an
    // exception happens during expose, then the worker will potentially not be exposed.  if done after, then
    // the worker will potentially be in the duplicate exposure scenario again.  given the rarity of the duplicate exposure
    // and our ability to track it via dataworker_wrongserver, for now we will risk the double exposure and
    // re-evaluate if needed.
    self.olkworkerexposed = true;
}
